import { BaseModel } from "../base.model";
import { DBFactory } from "classes/database/db_factory";

export type Organizations = Organization[];

type OrganizationContrusctorParams = {
  id?: string;
  name: string;
  hasLMSConfig?: boolean;
  externalOrganizationId?: string;
};

export class Organization extends BaseModel {
  id?: string;
  name: string;
  hasLMSConfig: boolean;
  externalOrganizationId?: string;

  constructor(data: OrganizationContrusctorParams) {
    super(data);

    this.id = data.id;
    this.name = data.name;
    this.hasLMSConfig = data.hasLMSConfig || false;
    this.externalOrganizationId = data.externalOrganizationId;
  }

  override get databaseConfig(): ModelDatabaseConfig {
    return {
      collection: "/organizations",
      path: `/organizations/${this.id}`,
    };
  }

  static override fromMap(map: any) {
    return new Organization(map);
  }

  override toMap(): ModelDatabaseData {
    return super.toMap();
  }

  async save() {
    const db = DBFactory.createDatabase();
    this.id = await db.save(this.toMap(), this.databaseConfig);
  }

  async delete() {
    const db = DBFactory.createDatabase();
    await db.delete(this.databaseConfig);
  }
}
